export default __webpack_public_path__ + "static/media/banner-needs.dd575c9b.jpg";